import React, { useEffect, useState } from 'react';
import { Fingerprint, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from './api';
import { goldBtn, ghostBtn } from './ui';
import { KEY, canUseBiometric, enroll } from './biometric';

// Proposes biometric login once per device after a code-based login.
export default function PasskeyPrompt({ who, client, base, onDone }) {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (localStorage.getItem(KEY(who))) return;
    canUseBiometric().then(setShow);
  }, [who]);
  if (!show) return null;
  const close = (v) => { localStorage.setItem(KEY(who), v); setShow(false); onDone?.(); };
  const go = async () => {
    setBusy(true);
    try { await enroll(client, base); toast.success('Accesso biometrico attivato su questo dispositivo'); close('on'); }
    catch (e) { if (e?.name !== 'NotAllowedError') toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[80] bg-black/60 grid place-items-center p-4" data-testid="passkey-prompt">
      <div className="w-full max-w-md bg-[#0B0D10] border border-[#1F242C] rounded-sm p-7 text-[#E5E5E5]">
        <Fingerprint size={30} className="text-[#D4AF37] mb-4" />
        <h3 className="font-heading text-xl mb-2">Accedi con impronta o volto</h3>
        <p className="text-sm text-[#A3A3A3] mb-6">Al prossimo accesso, dopo la password, confermi con impronta digitale, Face ID o Windows Hello invece del codice. Il codice resta disponibile come riserva. I dati biometrici restano sul dispositivo e non vengono mai inviati a BOND.</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={go} disabled={busy} className={`${goldBtn} h-11 px-5 text-sm inline-flex items-center gap-2`} data-testid="passkey-prompt-enable">{busy ? <Loader2 size={16} className="animate-spin" /> : <Fingerprint size={16} />}Attiva</button>
          <button onClick={() => close('no')} className={`${ghostBtn} h-11 px-5 text-sm`} data-testid="passkey-prompt-later">Non ora</button>
        </div>
      </div>
    </div>
  );
}
